import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';

export class VoucherCategoryFormAdapter extends CerFormAdapter {

  override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
        name: 'bilags-kategorier', dataApiName: 'VoucherCategory', text: 'Kategorier', textSingular: 'Kategori',
        primaryKey: 'id', baseFields: ['id', 'name', 'history']
      }
    });
  }

}
